
type Languages = 'nl-NL';
type Sections = 'Routes' | 'Footer' | 'Header' | 'BreadCrumb' | 'MegaMenu' | 'AllCategoriesExpandedMenu' | 'MiniCart' | 'Language' | 'productDetail' | 'USPDeliveryTerms' | 'AddressBook' | 'Cart' | 'CheckoutAddress' | 'Checkout' | 'Shipping' | 'Payment' | 'MultipleShipmentTable' | 'OrderConfirmation' | 'SignInPage' | 'Account' | 'AccountSummary' | 'ChangePasswordSection' | 'PersonalInformationSection' | 'WelcomeUserSection' | 'AdminTools' | 'BuyerManagement' | 'BuyerOrganizationAdminTools' | 'ApprovalsManagement' | 'BuyerApprovalDetails' | 'OrderApprovalDetails' | 'OrganizationManagement' | 'BuyerOrganizationRegistration' | 'BuyerUserRegistration' | 'Dashboard' | 'Order' | 'MyOrders' | 'OMSOrderStatus' | 'Category' | 'AccountLinksGridView' | 'AccountLinks' | 'MyAccount' | 'AddressCard' | 'AddressForm' | 'ChangePassword' | 'CheckoutProfile' | 'ChildPimCategories' | 'Confirmation' | 'FeaturedCard' | 'ForgotPassword' | 'PriceDisplay' | 'error-message' | 'success-message' | 'OrderBillingInfo' | 'OrderDetails' | 'OrderDiscountSummary' | 'OrderItemTable' | 'SaveForLaterTable' | 'OrderLinks' | 'OrderPaymentInfo' | 'OrderShippingInfo' | 'OrderTotalSummary' | 'PaymentMethodContainer' | 'PaymentInfoCard' | 'PaymentInfoList' | 'PaymentMethodSelection' | 'PersonalInformation' | 'ProductFilter' | 'ProductGrid' | 'PurchaseOrderNumber' | 'PurchaseOrderSelection' | 'RecurringOrderInfo' | 'RegistrationLayout' | 'RegistrationB2BLayout' | 'ResetPassword' | 'SearchBar' | 'SessionError' | 'SignIn' | 'Pickup' | 'SelectStore' | 'Inventory' | 'CommerceEnvironment' | 'RequisitionLists' | 'RequisitionListItems' | 'InprogressOrders' | 'InprogressItems' | 'commonTable' | 'WishList' | 'OrderMethod' | 'compare' | 'sellers' | 'StoreLocatorDialog' | 'StoreLocator' | 'StoreInventoryDialog' | 'StoreStock' | 'ClickAndCollect' | 'ProgressIndicator' | 'Files' | 'PasswordInput' | 'Common' | 'EmailTemplate' | 'FreeGift' | 'QuickOrder' | 'PrivacyPolicy' | 'UserInactivityAlert' | 'VerifiedAddress' | 'MergeCartDialog' | 'PdpExternalVideo' | 'NewsLetterSubscription' | 'AccountNewsLetterSubscription' | 'FormVaidations' | 'ReturnOrder' | 'StoreStockPage' | 'LegoLoyaltyForLego' | 'LegoLoyaltyForToet' | 'CancelOrderOMS' | 'ResendActivationEmail' | 'ScrollUp' | 'EaaMessages' | 'SearchResults' | 'RevokeOrder';
export type Translation = Record<string, string | MixedObj>;
interface MixedObj extends Translation {}
type ArgTypes = string | number;
type TemplateArgs = Record<string, ArgTypes>;

const manifest: Record<
    Languages | string,
    Record<Sections | string, () => Promise<Translation>>
> = {
    'nl-NL': {
        'Routes': () => import('./nl-NL/Routes'),
        'Footer': () => import('./nl-NL/Footer'),
        'Header': () => import('./nl-NL/Header'),
        'BreadCrumb': () => import('./nl-NL/BreadCrumb'),
        'MegaMenu': () => import('./nl-NL/MegaMenu'),
        'AllCategoriesExpandedMenu': () => import('./nl-NL/AllCategoriesExpandedMenu'),
        'MiniCart': () => import('./nl-NL/MiniCart'),
        'Language': () => import('./nl-NL/Language'),
        'productDetail': () => import('./nl-NL/productDetail'),
        'USPDeliveryTerms': () => import('./nl-NL/USPDeliveryTerms'),
        'AddressBook': () => import('./nl-NL/AddressBook'),
        'Cart': () => import('./nl-NL/Cart'),
        'CheckoutAddress': () => import('./nl-NL/CheckoutAddress'),
        'Checkout': () => import('./nl-NL/Checkout'),
        'Shipping': () => import('./nl-NL/Shipping'),
        'Payment': () => import('./nl-NL/Payment'),
        'MultipleShipmentTable': () => import('./nl-NL/MultipleShipmentTable'),
        'OrderConfirmation': () => import('./nl-NL/OrderConfirmation'),
        'SignInPage': () => import('./nl-NL/SignInPage'),
        'Account': () => import('./nl-NL/Account'),
        'AccountSummary': () => import('./nl-NL/AccountSummary'),
        'ChangePasswordSection': () => import('./nl-NL/ChangePasswordSection'),
        'PersonalInformationSection': () => import('./nl-NL/PersonalInformationSection'),
        'WelcomeUserSection': () => import('./nl-NL/WelcomeUserSection'),
        'AdminTools': () => import('./nl-NL/AdminTools'),
        'BuyerManagement': () => import('./nl-NL/BuyerManagement'),
        'BuyerOrganizationAdminTools': () => import('./nl-NL/BuyerOrganizationAdminTools'),
        'ApprovalsManagement': () => import('./nl-NL/ApprovalsManagement'),
        'BuyerApprovalDetails': () => import('./nl-NL/BuyerApprovalDetails'),
        'OrderApprovalDetails': () => import('./nl-NL/OrderApprovalDetails'),
        'OrganizationManagement': () => import('./nl-NL/OrganizationManagement'),
        'BuyerOrganizationRegistration': () => import('./nl-NL/BuyerOrganizationRegistration'),
        'BuyerUserRegistration': () => import('./nl-NL/BuyerUserRegistration'),
        'Dashboard': () => import('./nl-NL/Dashboard'),
        'Order': () => import('./nl-NL/Order'),
        'MyOrders': () => import('./nl-NL/MyOrders'),
        'OMSOrderStatus': () => import('./nl-NL/OMSOrderStatus'),
        'Category': () => import('./nl-NL/Category'),
        'AccountLinksGridView': () => import('./nl-NL/AccountLinksGridView'),
        'AccountLinks': () => import('./nl-NL/AccountLinks'),
        'MyAccount': () => import('./nl-NL/MyAccount'),
        'AddressCard': () => import('./nl-NL/AddressCard'),
        'AddressForm': () => import('./nl-NL/AddressForm'),
        'ChangePassword': () => import('./nl-NL/ChangePassword'),
        'CheckoutProfile': () => import('./nl-NL/CheckoutProfile'),
        'ChildPimCategories': () => import('./nl-NL/ChildPimCategories'),
        'Confirmation': () => import('./nl-NL/Confirmation'),
        'FeaturedCard': () => import('./nl-NL/FeaturedCard'),
        'ForgotPassword': () => import('./nl-NL/ForgotPassword'),
        'PriceDisplay': () => import('./nl-NL/PriceDisplay'),
        'error-message': () => import('./nl-NL/error-message'),
        'success-message': () => import('./nl-NL/success-message'),
        'OrderBillingInfo': () => import('./nl-NL/OrderBillingInfo'),
        'OrderDetails': () => import('./nl-NL/OrderDetails'),
        'OrderDiscountSummary': () => import('./nl-NL/OrderDiscountSummary'),
        'OrderItemTable': () => import('./nl-NL/OrderItemTable'),
        'SaveForLaterTable': () => import('./nl-NL/SaveForLaterTable'),
        'OrderLinks': () => import('./nl-NL/OrderLinks'),
        'OrderPaymentInfo': () => import('./nl-NL/OrderPaymentInfo'),
        'OrderShippingInfo': () => import('./nl-NL/OrderShippingInfo'),
        'OrderTotalSummary': () => import('./nl-NL/OrderTotalSummary'),
        'PaymentMethodContainer': () => import('./nl-NL/PaymentMethodContainer'),
        'PaymentInfoCard': () => import('./nl-NL/PaymentInfoCard'),
        'PaymentInfoList': () => import('./nl-NL/PaymentInfoList'),
        'PaymentMethodSelection': () => import('./nl-NL/PaymentMethodSelection'),
        'PersonalInformation': () => import('./nl-NL/PersonalInformation'),
        'ProductFilter': () => import('./nl-NL/ProductFilter'),
        'ProductGrid': () => import('./nl-NL/ProductGrid'),
        'PurchaseOrderNumber': () => import('./nl-NL/PurchaseOrderNumber'),
        'PurchaseOrderSelection': () => import('./nl-NL/PurchaseOrderSelection'),
        'RecurringOrderInfo': () => import('./nl-NL/RecurringOrderInfo'),
        'RegistrationLayout': () => import('./nl-NL/RegistrationLayout'),
        'RegistrationB2BLayout': () => import('./nl-NL/RegistrationB2BLayout'),
        'ResetPassword': () => import('./nl-NL/ResetPassword'),
        'SearchBar': () => import('./nl-NL/SearchBar'),
        'SessionError': () => import('./nl-NL/SessionError'),
        'SignIn': () => import('./nl-NL/SignIn'),
        'Pickup': () => import('./nl-NL/Pickup'),
        'SelectStore': () => import('./nl-NL/SelectStore'),
        'Inventory': () => import('./nl-NL/Inventory'),
        'CommerceEnvironment': () => import('./nl-NL/CommerceEnvironment'),
        'RequisitionLists': () => import('./nl-NL/RequisitionLists'),
        'RequisitionListItems': () => import('./nl-NL/RequisitionListItems'),
        'InprogressOrders': () => import('./nl-NL/InprogressOrders'),
        'InprogressItems': () => import('./nl-NL/InprogressItems'),
        'commonTable': () => import('./nl-NL/commonTable'),
        'WishList': () => import('./nl-NL/WishList'),
        'OrderMethod': () => import('./nl-NL/OrderMethod'),
        'compare': () => import('./nl-NL/compare'),
        'sellers': () => import('./nl-NL/sellers'),
        'StoreLocatorDialog': () => import('./nl-NL/StoreLocatorDialog'),
        'StoreLocator': () => import('./nl-NL/StoreLocator'),
        'StoreInventoryDialog': () => import('./nl-NL/StoreInventoryDialog'),
        'StoreStock': () => import('./nl-NL/StoreStock'),
        'ClickAndCollect': () => import('./nl-NL/ClickAndCollect'),
        'ProgressIndicator': () => import('./nl-NL/ProgressIndicator'),
        'Files': () => import('./nl-NL/Files'),
        'PasswordInput': () => import('./nl-NL/PasswordInput'),
        'Common': () => import('./nl-NL/Common'),
        'EmailTemplate': () => import('./nl-NL/EmailTemplate'),
        'FreeGift': () => import('./nl-NL/FreeGift'),
        'QuickOrder': () => import('./nl-NL/QuickOrder'),
        'PrivacyPolicy': () => import('./nl-NL/PrivacyPolicy'),
        'UserInactivityAlert': () => import('./nl-NL/UserInactivityAlert'),
        'VerifiedAddress': () => import('./nl-NL/VerifiedAddress'),
        'MergeCartDialog': () => import('./nl-NL/MergeCartDialog'),
        'PdpExternalVideo': () => import('./nl-NL/PdpExternalVideo'),
        'NewsLetterSubscription': () => import('./nl-NL/NewsLetterSubscription'),
        'AccountNewsLetterSubscription': () => import('./nl-NL/AccountNewsLetterSubscription'),
        'FormVaidations': () => import('./nl-NL/FormVaidations'),
        'ReturnOrder': () => import('./nl-NL/ReturnOrder'),
        'StoreStockPage': () => import('./nl-NL/StoreStockPage'),
        'LegoLoyaltyForLego': () => import('./nl-NL/LegoLoyaltyForLego'),
        'LegoLoyaltyForToet': () => import('./nl-NL/LegoLoyaltyForToet'),
        'CancelOrderOMS': () => import('./nl-NL/CancelOrderOMS'),
        'ResendActivationEmail': () => import('./nl-NL/ResendActivationEmail'),
        'ScrollUp': () => import('./nl-NL/ScrollUp'),
        'EaaMessages': () => import('./nl-NL/EaaMessages'),
        'SearchResults': () => import('./nl-NL/SearchResults'),
        'RevokeOrder': () => import('./nl-NL/RevokeOrder'),
    },
};

export interface TranslationTable {
	'Routes': {
	'Search': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Login': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Account': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MyOrders': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderDetails': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ReturnOrder': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ReturnOrderGuest': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'FavouriteStore': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PersonalInfo': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MyAddressBook': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ForgetMe': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AddressBook': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'WishLists': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderHistory': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CheckoutProfiles': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ForgotPassword': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ResetPassword': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Registration': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Cart': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CheckOut': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PunchoutPaymentRedirect': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PunchoutPaymentCallBack': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderConfirmation': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'SessionError': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Error404': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Error500': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreLocator': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreLocatorCity': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreLocatorStreet': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	};
	'CompareProducts': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerUserRegistration': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerOrganizationRegistration': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RequisitionLists': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RequisitionListDetails': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RequisitionListsUploadLogs': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RecurringOrders': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ApprovalsManagement': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerManagement': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerManagementCreate': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerManagementEdit': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrganizationManagement': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrganizationManagementCreate': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrganizationManagementEdit': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerApprovalDetails': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderApprovalDetails': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'HomePage': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'UserActivationCallBack': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'QuickOrder': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'NewsLetterSubscription': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'IntertoysNewsLetterSubscriptionSubmit': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'SubscriptionConfirmationView': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreStock': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CancelOrderOmsPage': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'SharedWishListView': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ResendActivationEmail': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RevokeOrder': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RevokeOrderGuest': {
	'route': {
	t: (args?: [...ArgTypes[]]) => string;};
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'keywords': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'Footer': {
	'CompanyLinks': {
	'Label': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OurStory': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Careers': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CopyrightFull': {
	t: ({date}: TemplateArgs) => string;};
	'Copyright': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CustomerService': {
	'Label': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactUs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactUsDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PrivacyPolicy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QuickOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'FollowUs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DisabledMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Header': {
	'Actions': {
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignInRegister': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignRegSeller': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WelcomeFirstName': {
	t: ({firstName}: TemplateArgs) => string;};
	'WelcomeNoFirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WishList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'YourAccount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Account': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PlayButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PlayButtonLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CustomerService': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Stores': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MyAccount': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AccountPopper': {
	'Welcome': {
	t: ({firstName}: TemplateArgs) => string;};
	'Organization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Contract': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Edit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountSetting': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignOut': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cart': {
	t: ({count}: TemplateArgs) => string;};
	'Done': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreClosed': {
	'Msg': {
	t: ({store}: TemplateArgs) => string;};
	};
	'NavBar': {
	'Acties': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ActiesLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cadeaus': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CadeausLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Merken': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MerkenLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Leeftijden': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LeeftijdenLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Kadokaart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'KadokaartLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'HelloRetail': {
	'PopularProducts': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoSearchResultsMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoSearchResultsMsgHeading': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	};
	};
	'Playbutton': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BreadCrumb': {
	'Home': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MegaMenu': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'ViewAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'AllCategoriesExpandedMenu': {
	'AllCategoriesLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'BackTo': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToOverview': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CLoseMenu': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'MiniCart': {
	'miniCartLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Items': {
	t: ({count}: TemplateArgs) => string;};
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Subtotal': {
	t: ({total}: TemplateArgs) => string;};
	'CalculatedLaterMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Empty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AndNMore': {
	t: ({count}: TemplateArgs) => string;};
	'Actions': {
	'Cart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckOut': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewOrderDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MyOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PrivateOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SharedOrderConributor': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SharedOrderAdmin': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Shipping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Free': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Language': {
	'-1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-3': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-4': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-5': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-6': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-7': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-8': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-10': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-20': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-21': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-9': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-22': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-23': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'productDetail': {
	'Quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QtyError': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Availability': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Seller': {
	t: ({seller}: TemplateArgs) => string;};
	'SellerSimple': {
	t: ({seller}: TemplateArgs) => string;};
	'AddBundleToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddKitToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddKitToSharedOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddBundleToSharedOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAttributes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DescriptionHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ProductDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Attachments': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Reviews': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AllAttachments': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Images': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Videos': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Documents': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PricePending': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addToCartErrorMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'any': {
	t: (args?: [...ArgTypes[]]) => string;};
	'showAttributes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'attributeFilter': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addToCurrentOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addToSharedOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noproductsToDisplay': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'skuLabel': {
	t: ({value}: TemplateArgs) => string;};
	'descAttrLabel': {
	t: ({name, values}: TemplateArgs) => string;};
	'PRODUCTSKU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PRODUCT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PRODUCTNAME': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QUANTITY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAnOption': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Unconfigured': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Unavailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Price': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Online_Availability': {
	t: (args?: [...ArgTypes[]]) => string;};
	'recommendedProdTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'someWithNoSkus': {
	t: (args?: [...ArgTypes[]]) => string;};
	'someWithNoAvlSelZero': {
	t: (args?: [...ArgTypes[]]) => string;};
	'someWithNoAvlPlsRemove': {
	t: (args?: [...ArgTypes[]]) => string;};
	'someWithNotEnough': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectSomething': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noAttributes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noproductsKit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addToRL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'createRL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addToWL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'createWL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QuantityValue': {
	t: ({quantity}: TemplateArgs) => string;};
	'hideAttrs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'removeFromSelection': {
	t: (args?: [...ArgTypes[]]) => string;};
	'chooseQuantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noAttrs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'detailsNotAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'descAttrLabelWithTagValues': {
	t: ({name}: TemplateArgs) => string;};
	'merchandisingAssociations': {
	t: (args?: [...ArgTypes[]]) => string;};
	'productRecommendations': {
	t: (args?: [...ArgTypes[]]) => string;};
	'commerceAIRecommendations': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RELEASE_DATE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MoreOf': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BRANDSERIES': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowMore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowLess': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowMoreARIA': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowLessARIA': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowMoreARIAProductSpecificaties': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowLessARIAProductSpecificaties': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClickAndCollect': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShopOnline': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WebOnlyProductTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WebOnlyProductDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PromoInfoICOARIA': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ArticleNummer': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'USPDeliveryTerms': {
	'USP_DHL_DELIVERY_TERM': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USP_PICKUP_IN_STORE_ENABLED_TEXT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USP_LDS_PICKUP_IN_STORE_ENABLED_TEXT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USP_DELIVERY_COST_1': {
	t: ({orderFreeShippingMinimumFinal}: TemplateArgs) => string;};
	'USP_DELIVERY_COST_2': {
	t: ({orderFreeShippingMinimumFinal}: TemplateArgs) => string;};
	'USP_DELIVERY_COST_3': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USP_STATIC_CONTENT': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AddressBook': {
	'AddrMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FilterLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoAddrMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoAddrForFilterMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowAllLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingBillingLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveChanges': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentDefaultDeliveryAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentDefaultShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Cart': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'GRATIS_TEXT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'Empty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PromoCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShopNow': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'PromoCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Frequency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StartDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderSummary': {
	t: (args?: [...ArgTypes[]]) => string;};
	'KlarnaText': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'Checkout': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContinueShopping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Apply': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutWithProfile': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Availability': {
	'NOT_AVAIL_PICKUP': {
	t: ({storeName}: TemplateArgs) => string;};
	'AVAIL_PICKUP': {
	t: ({storeName}: TemplateArgs) => string;};
	'NOT_AVAIL_DELIVERY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AVAIL_DELIVERY': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'FreeArticleSelection': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddButtonText': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'CheckoutAddress': {
	'Actions': {
	'Submit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Payment': {
	'ChooseFirst': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'Checkout': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutProfileTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'shipping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'payment': {
	t: (args?: [...ArgTypes[]]) => string;};
	'review': {
	t: (args?: [...ArgTypes[]]) => string;};
	'pickup-store': {
	t: (args?: [...ArgTypes[]]) => string;};
	'pickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'ReturnCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackTo': {
	t: ({step}: TemplateArgs) => string;};
	'ContinueTo': {
	t: ({step}: TemplateArgs) => string;};
	'PlaceOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Back': {
	'shipping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'pickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'payment': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Continue': {
	'pickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'payment': {
	t: (args?: [...ArgTypes[]]) => string;};
	'review': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PickupNotAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Shipping': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'UseMultiple': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddNewAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedCount': {
	t: ({selected, all}: TemplateArgs) => string;};
	'ItemsSelected': {
	t: ({itemsSelected}: TemplateArgs) => string;};
	'DHL_DELIVERY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DHL_DELIVERY_TEXT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'GRATIS_TEXT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'YourOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingFreeUpToText': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'SelectAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateNew': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Next': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Confirm': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Done': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'SelectExisting': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UseSavedAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Incomplete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectOrCreateAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectShipMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectDeleiveryAdress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'Payment': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TitleMulti': {
	t: ({total}: TemplateArgs) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectBillingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'UseMultiple': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PaymentMethod': {
	t: ({number}: TemplateArgs) => string;};
	'AddNewAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Most_commonly_used': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToPickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Next': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Finish': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveAndAdd': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddAnotherPayMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateNewAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'MultipleShipmentTable': {
	'Labels': {
	'ItemDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectShippingAddressAndMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChangeSelection': {
	t: (args?: [...ArgTypes[]]) => string;};
	'nItemsSel': {
	t: ({n}: TemplateArgs) => string;};
	'noItems': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderItems': {
	t: ({n}: TemplateArgs) => string;};
	'Select': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OutOfStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelInvalid': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'MissingSelection': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'OrderConfirmation': {
	'OrderedProducts': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingStoreAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PaymentMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Pending': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Details': {
	t: ({emails}: TemplateArgs) => string;};
	'PendingDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ThankYou': {
	t: ({storeName}: TemplateArgs) => string;};
	'OrderConfEmailText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderConfThankYouText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExpectedDeliveryDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HiringMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderConfirmationMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderPendingApprovalMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderScheduledMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShipRequestedDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderPunchOutPaymentUnsuccessful': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderPendingMsgs': {
	'WAT_NU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QSTN_1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ANS_1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QSTN_2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ANS_2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'QSTN_3': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ANS_3': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Title': {
	'OrderCompleted': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderPendingPunchoutPayment': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderPunchOutPaymentUnsuccessful': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'ShopNow': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'SignInPage': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Account': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AccountSummary': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ChangePasswordSection': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VerifyPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OkLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PersonalInformationSection': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Name': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PhoneNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveChanges': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UpdateSuccessful': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'WelcomeUserSection': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TitleExt': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Message': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AdminTools': {
	'buyerManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orgAndBuyer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orgManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'buyerManagementDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orgAndBuyerDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orgManagementDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'adminTools': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerManagement': {
	'buyerList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'firstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'lastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'logonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'role': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchByLogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'access': {
	t: (args?: [...ArgTypes[]]) => string;};
	'actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noBuyer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'disableUser': {
	t: (args?: [...ArgTypes[]]) => string;};
	'enableUser': {
	t: (args?: [...ArgTypes[]]) => string;};
	'resetPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'enabled': {
	t: (args?: [...ArgTypes[]]) => string;};
	'disabled': {
	t: (args?: [...ArgTypes[]]) => string;};
	'include': {
	t: (args?: [...ArgTypes[]]) => string;};
	'exclude': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedGroups': {
	t: (args?: [...ArgTypes[]]) => string;};
	'IncludeMemberGroups': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EncludeMemberGroups': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AvailableGroups': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Edit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstLast': {
	t: ({firstName, lastName}: TemplateArgs) => string;};
	'Actions': {
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Next': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Save': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Finish': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StepperLabels': {
	'AccountInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Roles': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Groups': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AccountLabels': {
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VerifyPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountPolicy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAccountPolicy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ParentOrgName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PhoneNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreferredCurrency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectPreferredCurrency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreferredLanguage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectPreferredLanguage': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ContactLabels': {
	'AddressLine1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressLine2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'City': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Country': {
	t: (args?: [...ArgTypes[]]) => string;};
	'State': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ZipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RolesLabels': {
	'SelectedRolesText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectRoleText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchRoles': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoSelectionText': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'SelectRole': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectParentOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectUserAccountStatus': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchOptions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UserAccountStatus': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ParentOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Search': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClearResults': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerCreated': {
	t: ({logonId}: TemplateArgs) => string;};
	'BuyerUpdated': {
	t: ({logonId}: TemplateArgs) => string;};
	};
	'BuyerOrganizationAdminTools': {
	'BuyerManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerOrderApproval': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderApproval': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerManagementDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerOrderApprovalDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderApprovalDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgManagementDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AdminTools': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ApprovalsManagement': {
	'ApprovalsManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approve': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Reject': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Columns': {
	'ApprovalId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Buyer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Submitted': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApprovedOrRejected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Pending': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approved': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Rejected': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'NoItem': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchOptions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchByOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchByApproval': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Refresh': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerFirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerLastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApprovalID': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderID': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StartDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EndDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewPending': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewApproved': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewRejected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Search': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClearResults': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidBuyerName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyersTab': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrdersTab': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerApprovalDetails': {
	'Approve': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Reject': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Submitted': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CommentsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CommentsSubtitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CommentsTextPlaceHolder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerDetailsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgDetailsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Organization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Name': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreferredLanguage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreferredCurrency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoComments': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FullName': {
	t: ({firstName, lastName}: TemplateArgs) => string;};
	};
	'OrderApprovalDetails': {
	'Status_W': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_M': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_N': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToAM': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderedBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Organization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CommentsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CommentsSubtitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CommentsTextPlaceHolder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approve': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Reject': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoComments': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrganizationManagement': {
	'OrganizationName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DistinguishedName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrganizationManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Type': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoItem': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewOrganizationButtonText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrganizationDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NameOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DescriptionOptional': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ParentOrg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactFirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactLastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StreetAddressLine1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StreetAddressLine2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'City': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Country': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateProvinceRegion': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ZipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Roles': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approvals': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CancelButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FinishButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedRoles': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoRolesSelectedText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectApprovalTypesAvailableText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectApprovalTypesHeader': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedApprovalTypesHeader': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoApprovalTypesSelected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NameSearchPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ParentOrgPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EntityType_O': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EntityType_OU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClearResults': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approval_Inherited_OrderApprovalGroup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approval_Inherited_UserRegistrationApprovalGroup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approval_OrderApprovalGroup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approval_DisableInherited_OrderApprovalGroup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approval_UserRegistrationApprovalGroup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Approval_DisableInherited_UserRegistrationApprovalGroup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrganizationCreated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrganizationUpdated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectParentOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditOrganization': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RolesNotModifiable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchRoles': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerOrganizationRegistration': {
	'OrganizationRegistration': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerAdminRegistration': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressLineAdd': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextRegister': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CompleteRegistration': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HaveAnAccount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HereAnAccount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrganizationName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountPreferences': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'City': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Country': {
	t: (args?: [...ArgTypes[]]) => string;};
	'State': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ZipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Language': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Currency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UseOrganizationAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Submit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Clear': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Success': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OK': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AutoApproved': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ZipCodePostalCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'BuyerUserRegistration': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'City': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Country': {
	t: (args?: [...ArgTypes[]]) => string;};
	'State': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ZipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Language': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Currency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountPreferences': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HaveAccount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressLineAdd': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Submit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Clear': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Success': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OK': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'Dashboard': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountSettings': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressBook': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderManagement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistory': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RequisitionLists': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InprogressOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApproveOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Order': {
	'noPO': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_A': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_B': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_C': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_D': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_F': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_G': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_I': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_K': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_L': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_M': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_N': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_P': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_R': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_S': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_T': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_W': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_V': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_X': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_RTN': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status_APP': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NotAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PONumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Schedule': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RowCount': {
	t: ({from, to, count}: TemplateArgs) => string;};
	'NoRecord': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidOrderId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Search': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PageSizeLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreviousPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistory': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Once': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EveryXDAY': {
	t: ({frequency}: TemplateArgs) => string;};
	'EveryXWEE': {
	t: ({frequency}: TemplateArgs) => string;};
	'EveryXMON': {
	t: ({frequency}: TemplateArgs) => string;};
	'StateInActive': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateInactive': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateActive': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateExpired': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateCancelled': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateCompleted': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StateSuspended': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StatePendingCancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TooltipCancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TooltipReOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FilterResults': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HistorySearchPlaceHolder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HistoryViewDetailTooltip': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Pending': {
	t: (args?: [...ArgTypes[]]) => string;};
	'multiStatus': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToOH': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TooltipOrderIdSearch': {
	t: (args?: [...ArgTypes[]]) => string;};
	'purchaseOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PlacedDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalProductPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Items': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INGENICO_PAYMENT_STATUS_CREATED': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INGENICO_PAYMENT_STATUS_UNSUCCESSFUL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INGENICO_PAYMENT_STATUS_PENDING_PAYMENT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INGENICO_PAYMENT_STATUS_PENDING_CONNECT_OR_3RD_PARTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INGENICO_PAYMENT_STATUS_PENDING_MERCHANT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INGENICO_PAYMENT_STATUS_COMPLETED': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LEGACY_INGENICO_PAYMENT_STATUS_PAYMENT_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LEGACY_INGENICO_PAYMENT_STATUS_PAYMENT_FAILED': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Date': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ProdcuQuantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PurchaseTotal': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderLineHeader': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewInvoice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RevokeOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MyOrders': {
	'NoRecord': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DetailHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HeadingDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DetailHeadingDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'yourOrderData': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OMSOrderStatus': {
	'OrderStatus_I': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_M': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_C': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_S': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_W': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_N': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_B': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_R': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_D': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_L': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_A': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_F': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_G': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_K': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_V': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_X': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_T': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderStatus_P': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NOT_AVAILABLE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PaymentStatus': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Category': {
	'notAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Category': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OverlayCategoryText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubCategoryNavARIALABEL': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AccountLinksGridView': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressBookText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressBookDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistoryText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistoryDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WishListText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WishListDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutProfilesText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutProfilesDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RequisitionListsText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RequisitionListsDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrdersText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrdersDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MyAccountText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MyAccountTextDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MyOrderstText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MyOrdersTextDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ReturnOrderText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RevokeOrderText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ReturnOrderDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RevokeOrderDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FavouriteStoreText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FavouriteStoreDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FavouriteStorePageHeadline': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInfoText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInfoDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInfoPageHeadline': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgetMeText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgetMeDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgetMeHeadline': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgetMeBodyText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgetMeButtonText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgetMeConfirmationText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogoutText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogoutTextDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Confirm': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sidebarNavigation': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AccountLinks': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInformationText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInformationDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressBookText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressBookDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DisabledMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MyAccount': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountSettings': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressBook': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistory': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Wishlists': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutProfiles': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoAccountAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecentOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AddressCard': {
	'EditButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Confirm': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UseAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressChange': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CountryValue': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AddressForm': {
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidAddressName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressNotFound_POSTNL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidFirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidLastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidPostcode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidHouseNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidPhone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidStreet': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidCity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AgeNotAllowed': {
	t: (args?: [...ArgTypes[]]) => string;};
	'IncompleteBirthday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExPhoneFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExEmailFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Address3': {
	t: (args?: [...ArgTypes[]]) => string;};
	'City': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Country': {
	t: (args?: [...ArgTypes[]]) => string;};
	'State': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ZipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailPlaceHolder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NickName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressType': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Shipping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Billing': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingAndBilling': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Gender': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Day': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Month': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Year': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Child': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddressInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Children': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChildFirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChildDateOfBirth': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveChanges': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveAndSelect': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Delete': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ChangePassword': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VerifyPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CancelLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OkLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CheckoutProfile': {
	'ShippingInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateCheckoutTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateCheckoutButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PaymentInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShipSameAsBill': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Next': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateProfile': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UpdateProfile': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Label': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MyAcctDesc': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Name': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Edit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Delete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoneFound': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoProfiles': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TitleCreate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateNewButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingAddr': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingMethodDisp': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingAddr': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditProfile': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShipAsComplete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'confirmDelete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectExisting': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sm_Express': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sm_Mail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sm_InternationalPriority': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sm_InternationalRegular': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sm_PickupInStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'saveAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'invalidProfile': {
	t: (args?: [...ArgTypes[]]) => string;};
	'invalidProfileName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectExpMonth': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectExpYear': {
	t: (args?: [...ArgTypes[]]) => string;};
	'none': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectPaymentMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'payMethods': {
	'VISA': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MasterCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AMEX': {
	t: (args?: [...ArgTypes[]]) => string;};
	'COD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApplePay': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillMeLater': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Check': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PayInStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PayLater': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ChildPimCategories': {
	'title': {
	t: ({name}: TemplateArgs) => string;};
	};
	'Confirmation': {
	'ScheduleOrderCancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ScheduleOrderCancelNotification': {
	t: ({next}: TemplateArgs) => string;};
	'CancelRecurringOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubmitButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CancelButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'FeaturedCard': {
	'ShopNow': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ForgotPassword': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubmitButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogonIDLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContentText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContentTextLogonID': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ValidationCodeButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SendVerificationCodeButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CodeReceived': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountInfoRemember': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ResetPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ResetPasswordFormTextHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ResetPasswordFormText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PriceDisplay': {
	'Labels': {
	'Pending': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PerUnit': {
	t: ({price}: TemplateArgs) => string;};
	'UnitPrice': {
	t: ({price}: TemplateArgs) => string;};
	'EaaOfferPriceText': {
	t: ({eaaOffer}: TemplateArgs) => string;};
	'EaaListAndOfferPriceText': {
	t: ({eaaOffer, eaaList}: TemplateArgs) => string;};
	};
	};
	'error-message': {
	'ViewCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2020': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2050': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2070': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5060': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5066': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5210': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2190': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2080': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_LOGONID_ALREDY_EXIST_2030': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PASSWORDS_NOT_SAME_2080': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_USER_ALREADY_REGISTERD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_MINIMUMLENGTH_PASSWORD_2200': {
	t: (args: [ArgTypes, ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_MAXCONSECUTIVECHAR_PASSWORD_2210': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_MAXINTANCECHAR_PASSWORD_2220': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_MINIMUMLETTERS_PASSWORD_2230': {
	t: (args: [ArgTypes, ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_MINIMUMDIGITS_PASSWORD_2240': {
	t: (args: [ArgTypes, ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_USERIDMATCH_PASSWORD_2250': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_REUSEOLD_PASSWORD_2260': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2040': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2060': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2070': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2200': {
	t: (args: [ArgTypes, ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_2210': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_2220': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_2230': {
	t: (args: [ArgTypes, ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_2240': {
	t: (args: [ArgTypes, ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_BAD_PARMS_2050': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_BAD_PARMS_2080': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2250': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2260': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_ERROR_2000': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_ERROR_2010': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_ERROR_2020': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_ERROR_2030': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PASSWORD_FAILED_CMN1019E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PERSON_ACCOUNT_DISABLED_2110': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PERSON_ACCOUNT_LOCKED_OUT_2490': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_LOGIN_NOT_ALLOWED_NOW_2300': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2400': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2410': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2420': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2450': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PERSON_ACCOUNT_PENDING_EMAIL_ACTIVATION_2450': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2430': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_2570': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_GENERIC_2110': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_MISSING_PARMS_2000': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_MISSING_PARMS_2010': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_BAD_PARMS_2010': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_MISSING_PARAM_2020': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_MISSING_PARMS_2040': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_MISSING_PARMS_2060': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_MISSING_PARMS_2070': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_MISSING_PARMS_2100': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_BAD_PARMS_1020': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5080': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5100': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5120': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5140': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5160': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_5030': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_NICKNAME_ALREDY_EXIST_5040': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_MISSING_PARAM_2000': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2010': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_PROMOTION_CODE_INVALID_-1200': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_PROMOTION_CODE_INVALID': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_PROMOTION_NOT_AVAILABLE_AT_THIS_TIME_-2200': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_PROMOTION_PER_SHOPPER_LIMIT_EXCEEDED_-1800': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'ERR_PROMOTION_OVERALL_LIMIT_EXCEEDED_-1900': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'ERR_PROMOTION_SYSTEM_ERR_-2700': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_PROMOTION_CODE_DUPLICATED_-1150': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'ERR_PROMOTION_UNKNOWN_ERR_-2600': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_FORMAT_PROMOCODES_NOT_CORRECT_-2820': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PARAMETER_MISSING_-2810': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_FORMAT_ORDERIDS_NOT_CORRECT_-2830': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PAY_CARD_NUMBER_MISSING_190': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PAY_CARD_BRAND_MISSING_190': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CREATE_PAYMENT_METHOD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CREATE_PAYMENT_METHOD_1007': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PAY_CARD_NUMBER_INVALID_1005': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_DBG_API_PAY_BAD_LEN_OR_PREFIX_1005': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_DBG_API_DO_PAYMENT_BAD_XDATE_1006': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PAY_EXPIRY_DATE_INVALID_1006': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CREATE_PAYMENT_METHOD_CMN1112E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_RDN_ALREADY_EXIST': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_parentMemberId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_parentMember': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_org_orgEntityName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_API_BAD_INV_2': {
	t: (args: [ArgTypes, ArgTypes, ...ArgTypes[]]) => string;};
	'_API_BAD_INV_DELIVERY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_API_BAD_INV_PICKUP': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_FINDING_ORDER_230': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_INTERNAL_SERVER_ERROR_CWXFR0230E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_REMOTE_EXCEPTION_CMN0412E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_REG_DUPE_ID_CMN0114S': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_FINDER_EXCEPTION_CMN0411E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CMD_INVALID_PARAM_2195': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PASSWORD_EXPIRED_2170': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_INVALID_NAME_CMN1652E': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_GOOGLE_MAP_NOT_SUPPORT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HTTP_404_NOT_FOUND': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HTTP_500_INTERNAL_SERVER_ERROR': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoCopyOrderItems': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_CATALOG_ENTRY_MARK_FOR_DELETE_CWXCO3006E': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USER_MESSAGE_KEY1__ERR_USER_ADDR_CANNOT_BE_SAME_AS_STORE_ADDR': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PDP_SELECT_STORE_BEFORE_ADD2CART': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PDP_CLICK_AND_COLLECT_NOT_AVAILABLE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_HOME_DELIVERY_UNAVAILABLE_PICKUP_ONLY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PICKUP_ONLY_ITEM': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PROMOTION_PER_SHOPPER_LIMIT_EXCEEDED_TREAZURE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_PROMOTION_CONDITIONS_NOT_MET': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_ITNL_API_BAD_INV_CLICK_AND_DELIVERY': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_ITNL_API_BAD_INV_CLICK_AND_DELIVERY_V1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_ITNL_API_BAD_INV_CLICK_AND_DELIVERY_ITNL1023E': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_CC_QTY_CHECK_MSG': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectStoreToAddToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_AUTHENTICATION_COMMON_KEYWORD_PASSWORD_2270': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_API_BAD_INV': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_PROD_NOT_ORDERABLE': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_PRODUCT_NOT_SUPPORT_CC': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_INVALID_LOGIN': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_GENERIC_NEWS_LETTER_SUBSC': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_ORDER_MAX_ORDER_LIMIT_REACHED_WISHLIST': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERR_OOS_ITEM_IN_CART': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'_ERR_PAY_METHOD_PRODUCT_CANT_BE_USED': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_ORDER_LOCKED': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_VIEW_INVOICE': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'success-message': {
	'ITEM_ADD_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'COPY_CART_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrderCancelled': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ADD_ADDRESS_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EDIT_ADDRESS_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DELETE_ADDRESS_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RESEND_VERIFICATION_CODE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PASSWORD_RESET_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CREATE_CHECKOUT_PROFILE_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'COPY_ORDER_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CREATE_ORDER_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'DELETE_ORDER_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'CREATE_REQUISITIONLIST_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'DELETE_REQUISITIONLIST_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'UPDATED_REQUISITIONLIST_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeletedCheckoutProfile': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'UpdatedCheckoutProfile': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'deletedSuccessfully': {
	t: ({n}: TemplateArgs) => string;};
	'addedItemSuccessfully': {
	t: ({v}: TemplateArgs) => string;};
	'addedNSuccessfully': {
	t: ({v}: TemplateArgs) => string;};
	'addedItemRLSuccessfully': {
	t: ({v}: TemplateArgs) => string;};
	'addedNRLSuccessfully': {
	t: ({v}: TemplateArgs) => string;};
	'deletedItemListSuccessfully': {
	t: ({count}: TemplateArgs) => string;};
	'CREATE_WISHLIST_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DELETE_WISHLIST_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DELETE_WISHLIST_ITEM_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DELETE_WISHLIST_ITEMS_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'WISHLIST_ADD_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addItemListSuccessfully': {
	t: ({v}: TemplateArgs) => string;};
	'addNItemsSuc': {
	t: ({n}: TemplateArgs) => string;};
	'UPDATE_WISHLIST_NAME_SUCCESS': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'ITEM_TO_CART': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'ITEMS_N_TO_CART': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'CopyOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PartialCopyOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'userAccountEnabled': {
	t: ({logonId}: TemplateArgs) => string;};
	'userAccountDisabled': {
	t: ({logonId}: TemplateArgs) => string;};
	'userPasswordReset': {
	t: ({logonId}: TemplateArgs) => string;};
	'BUYER_APPROVAL_APPROVE_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BUYER_APPROVAL_REJECT_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ORDER_APPROVAL_APPROVE_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ORDER_APPROVAL_REJECT_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PRIVACY_POLICY_ACCEPTED': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ITEM_ADDED_TO_SAVE_FOR_LATER_LIST': {
	t: ({name}: TemplateArgs) => string;};
	'ITEM_DELETED_FROM_SAVE_FOR_LATER_LIST': {
	t: ({name}: TemplateArgs) => string;};
	'ITEM_MOVED_TO_CART_FROM_SAVE_FOR_LATER_LIST': {
	t: ({name}: TemplateArgs) => string;};
	'ALL_ITEMS_MOVED_TO_CART_FROM_SAVE_FOR_LATER_LIST': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ALL_ITEMS_DELETED_FROM_SAVE_FOR_LATER_LIST': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USER_DELETE_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WISHLIST_EMAILED_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderBillingInfo': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'BillAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'OrderDetails': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Next': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextRecurringOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DownloadInvoice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ReturnOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToOverview': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'PaymentDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderSummary': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Empty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExpectedDeliveryDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'GratisText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PaymentMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'YourOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PartNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Qunatity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SplitPayment': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Summary': {
	'Labels': {
	'TotalAmount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingCharge': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalDiscunt': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalAmountIncludingVAT': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	};
	'OrderDiscountSummary': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'Total': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'OrderItemTable': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'ItemDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Availability': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Price': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Gift': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NonRecurring': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PageSizeLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreviousPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextPage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RowCount': {
	t: ({from, to, count}: TemplateArgs) => string;};
	'showAttrs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'hideAttrs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RemoveFromCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Empty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ProductThumbnail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveForLater': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupReadonly': {
	t: ({pickItemsNumber}: TemplateArgs) => string;};
	'Pickup': {
	t: ({selectedStore, pickItemsNumber}: TemplateArgs) => string;};
	'Delivery': {
	t: ({deliveryItemsNumber}: TemplateArgs) => string;};
	'PreferPickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FulfillmentType': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'ReleaseDate': {
	t: ({releaseDate}: TemplateArgs) => string;};
	'SpeelboekMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Fulfillment': {
	'Delivery': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Pickup': {
	t: ({store}: TemplateArgs) => string;};
	};
	'Actions': {
	'Delete': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'SaveForLaterTable': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'ItemDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Price': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ProductThumbnail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MoveToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: ({partNumber}: TemplateArgs) => string;};
	'MoveAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'Delete': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'ReleaseDate': {
	t: ({releaseDate}: TemplateArgs) => string;};
	};
	};
	'OrderLinks': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistoryText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistoryDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InprogressOrdersText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InprogressOrdersDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrdersText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrdersDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApproveOrdersText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApproveOrdersDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RequisitionListsText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RequisitionListsDescription': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderPaymentInfo': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'BillMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'OrderShippingInfo': {
	'Labels': {
	'ShipAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShipMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CartDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShipmentGroup': {
	t: ({index}: TemplateArgs) => string;};
	'HideGroupDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowGroupDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'OrderTotalSummary': {
	'Labels': {
	'Subtotal': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Tax': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Shipping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingTax': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Discount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Total': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Free': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PaymentMethodContainer': {
	'Actions': {
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Done': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveAndAdd': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PaymentInfoCard': {
	'Title': {
	t: ({number}: TemplateArgs) => string;};
	'Labels': {
	'CreditCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AmountToPay': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExpiryDate': {
	t: ({month, year}: TemplateArgs) => string;};
	'BillingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'Edit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Delete': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PaymentInfoList': {
	'Title': {
	'PayMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WithOrderTotal': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'PayMethodRequired': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InsufficientPayment': {
	t: ({grandTotal}: TemplateArgs) => string;};
	'CardDetailsUpdate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PayMethodNote': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PaymentAmountError': {
	t: ({paymentsTotal, grandTotal}: TemplateArgs) => string;};
	'notValidForMulti': {
	t: ({type}: TemplateArgs) => string;};
	};
	'Actions': {
	'AddPayMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PaymentMethodSelection': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'CreditCard': {
	t: ({cards}: TemplateArgs) => string;};
	'CVV': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidCardNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectPaymentMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'COD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreditCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CCNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExpiryDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CVV': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderTotal': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RemainingAmount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AmountToPay': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PayTooMuch': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExpiryMonth': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExpiryYear': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Choose': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'PayRemaining': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PaymentMethods': {
	'VISA': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MasterCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DE Giftcard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VVV Giftcard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Intertoys Giftcard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'KidsCadeau': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PersonalInformation': {
	'UpdateSuccessful': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Edit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChangePassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditAccountInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PhoneNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PreferredCurrency': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Gender': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectGender': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BirthYear': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BirthMonth': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BirthDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectYear': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectMonth': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DateOfBirthEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SaveChanges': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VerifyPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignOutButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'actingAs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'resetPass': {
	t: (args?: [...ArgTypes[]]) => string;};
	'resetSure': {
	t: (args?: [...ArgTypes[]]) => string;};
	'resetNo': {
	t: (args?: [...ArgTypes[]]) => string;};
	'resetYes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'stopActing': {
	t: (args?: [...ArgTypes[]]) => string;};
	'guestUser': {
	t: (args?: [...ArgTypes[]]) => string;};
	'register': {
	t: (args?: [...ArgTypes[]]) => string;};
	'enableUser': {
	t: (args?: [...ArgTypes[]]) => string;};
	'disableUser': {
	t: (args?: [...ArgTypes[]]) => string;};
	'disabledMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PersonalInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'B2BContactInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CompanyName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChamberOfCommerceNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VATNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ProductFilter': {
	'Labels': {
	'filterBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noFilters': {
	t: (args?: [...ArgTypes[]]) => string;};
	'price': {
	t: (args?: [...ArgTypes[]]) => string;};
	'minPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'maxPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'category': {
	t: (args?: [...ArgTypes[]]) => string;};
	'artikelen': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ariaLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'showMore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'showLess': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Filter': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowResults': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ProductGrid': {
	'Labels': {
	'filteredBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'productFound': {
	t: ({count}: TemplateArgs) => string;};
	'productSearchFound': {
	t: ({count, searchTerm}: TemplateArgs) => string;};
	'noMatches': {
	t: ({searchTerm}: TemplateArgs) => string;};
	'searchAgain': {
	t: ({searchTerm}: TemplateArgs) => string;};
	'suggestion': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noProductsFound': {
	t: ({keyword}: TemplateArgs) => string;};
	'noProductsFoundForFilter': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sortBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'gtmItemList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'gtmSearchResults': {
	t: ({term}: TemplateArgs) => string;};
	'SearchProductsCount': {
	t: ({searchTerm, count}: TemplateArgs) => string;};
	'ProductsCount': {
	t: ({count}: TemplateArgs) => string;};
	};
	'Actions': {
	'clearAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'PurchaseOrderNumber': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'PONumberRequired': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'PONumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'display': {
	t: ({poNumber}: TemplateArgs) => string;};
	};
	};
	'PurchaseOrderSelection': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Labels': {
	'PONumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'RecurringOrderInfo': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'RecurringOrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderSchedule': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StartDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NextDelivery': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderHistoryButton': {
	t: ({orderId}: TemplateArgs) => string;};
	};
	};
	'RegistrationLayout': {
	'NewCustomer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Account': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'emailPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VerifyPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TextContent': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Register': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RegisterComplete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RegisterUser': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RememberMe': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RegisterInfoPopup': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InfoText1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InfoText2': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'RegistrationB2BLayout': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'BuyerReg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgReg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddBuyer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddOrg': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ResetPassword': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ValidationCodeLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'VerifyPasswordLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubmitButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContentText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContentTextLogonID': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LogonIDLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PasswordNotReceived': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ResendVerificationCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountInfoRemember': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'SearchBar': {
	'SearchField': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchIconLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Keyword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Category': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Brand': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Seller': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Clear': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'SessionError': {
	'TimeoutTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'GenericTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TimeoutMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidMsgB2C': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubmitButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CancelButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PartialAuthError': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ActionIncomplete': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'SignIn': {
	'ReturningCustomer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChangePassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PasswordVerify': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RememberMe': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignInButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignInAndCheckoutButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignInAndCheckoutTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutAsGuestMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckoutAsGuestButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Submit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ForgotPassword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ResendActivationEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noAccount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'registerNow': {
	t: (args?: [...ArgTypes[]]) => string;};
	'emailPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Label': {
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'rememberMe': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'InvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PasswordNotMatch': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OldPasswordReuse': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecurringOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'Pickup': {
	'PickupOrderMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'IllPickupRadioLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SomeoneElseRadioLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HowPickupOrderMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmailMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContinueMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ProceedPayment': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FirstName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContinuePickupDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BackToPickupStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContinueCheckout': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupPersonFullName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupPersonEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BuyerFullName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupContactTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupStoreTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ContactDetailsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupDetailsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeliveryMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedStore': {
	t: ({storeName}: TemplateArgs) => string;};
	};
	'SelectStore': {
	'PickupFrom': {
	'SelectAStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PhysicalStore': {
	t: ({physicalStore}: TemplateArgs) => string;};
	};
	};
	'Inventory': {
	'AddToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChooseOptions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ChooseOptionsText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ByCount': {
	'Delivery': {
	'Available': {
	t: ({count}: TemplateArgs) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AtStore': {
	'Available': {
	t: ({count, store}: TemplateArgs) => string;};
	'OOS': {
	t: ({store}: TemplateArgs) => string;};
	};
	'ForDelivery': {
	'Available': {
	t: ({count}: TemplateArgs) => string;};
	'NoInventoryShow': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ForPickup': {
	'Available': {
	t: ({count}: TemplateArgs) => string;};
	'NoInventoryShow': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ByOrder': {
	'Available': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Unavailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ByOrderPartial': {
	'PartialAvailable': {
	t: ({numberOfAvailable, numberOfTotal}: TemplateArgs) => string;};
	};
	'ByWay': {
	'Delivery': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Available': {
	t: ({count}: TemplateArgs) => string;};
	'NoInventoryShow': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Pickup': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAStoreLinkable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PickupSelectAStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckOtherStores': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Available': {
	t: ({count, store}: TemplateArgs) => string;};
	'NoInventoryShow': {
	t: ({store}: TemplateArgs) => string;};
	'OOS': {
	t: ({store}: TemplateArgs) => string;};
	};
	};
	'Drawer': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InStockLocations': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Placeholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SetAsMyStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentSelectedStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreInfo': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: ({phoneNumber}: TemplateArgs) => string;};
	'UseCurrentLocation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Available': {
	t: ({count}: TemplateArgs) => string;};
	'NoInventoryShow': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'CommerceEnvironment': {
	'listSettings': {
	'relevance': {
	t: (args?: [...ArgTypes[]]) => string;};
	'brands': {
	t: (args?: [...ArgTypes[]]) => string;};
	'name': {
	t: (args?: [...ArgTypes[]]) => string;};
	'priceLowToHigh': {
	t: (args?: [...ArgTypes[]]) => string;};
	'priceHighToLow': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'inventoryStatus': {
	'Available': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Unavailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Allocated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Unallocated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Backordered': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NA': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'inventoryStatusOnline': {
	'Available': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Allocated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Unallocated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Backordered': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NA': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'inventoryStatusStore': {
	'Available': {
	t: ({store}: TemplateArgs) => string;};
	'Allocated': {
	t: ({store}: TemplateArgs) => string;};
	'Unallocated': {
	t: ({store}: TemplateArgs) => string;};
	'Backordered': {
	t: ({store}: TemplateArgs) => string;};
	'OOS': {
	t: ({store}: TemplateArgs) => string;};
	'NA': {
	t: ({store}: TemplateArgs) => string;};
	};
	'recurringOrderFrequency': {
	'Everyday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EveryWeek': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EveryTwoWeeks': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EveryThreeWeeks': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EveryFourWeeks': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'languagePopUp': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Message': {
	t: ({language}: TemplateArgs) => string;};
	'Yes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'No': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'currency': {
	'ROL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RON': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ARS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ATS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AUD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BEF': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BRL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CAD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CNY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DEM': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ESP': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EUR': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FRF': {
	t: (args?: [...ArgTypes[]]) => string;};
	'GBP': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HKD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ITL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'JPY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'KRW': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SGD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TWD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'USD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ZAR': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FIM': {
	t: (args?: [...ArgTypes[]]) => string;};
	'IEP': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LUF': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NLG': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PTE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NOK': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SEK': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DKK': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CHF': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PLN': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RUB': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EGP': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'language': {
	'-1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-3': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-4': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-5': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-6': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-7': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-8': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-10': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-21': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-20': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-9': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-22': {
	t: (args?: [...ArgTypes[]]) => string;};
	'-23': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'RequisitionLists': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateNewRequisitionList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewRequisitionName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PrivateList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SharedList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Visibility': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UploadRequisitionList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DownloadInstructionsWithAnExample': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewUploadLogs': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoViewRecord': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoRecord': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Browse': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedFile': {
	t: ({file}: TemplateArgs) => string;};
	'Columns': {
	'ListName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreatedBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Items': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DateCreated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastUpdate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Type': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CreatedBy': {
	t: ({firstName, lastName}: TemplateArgs) => string;};
	'Type': {
	'Y': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Z': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'DeleteDialogTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteDialogHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CopyTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CopyMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidListName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchPh': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessfullyCreatedRequisitionList': {
	t: ({name}: TemplateArgs) => string;};
	'UploadLog': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UploadedFile': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Status': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UploadTime': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewLog': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UpdNofM': {
	t: ({n, m}: TemplateArgs) => string;};
	'PartialCompleteStatusTop': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FailedStatusTop': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PartialCompleteStatusBottom': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FailedStatusBottom': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LineNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PartiallyUploaded': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Processing': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Uploaded': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UploadFailed': {
	t: (args?: [...ArgTypes[]]) => string;};
	'search': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Add': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKUSearch': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoSKUFound': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmptyRL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Refresh': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CopyList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'nameForCopiedList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddListToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectUploadFile': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RequisitionListItems': {
	'noItems': {
	t: (args?: [...ArgTypes[]]) => string;};
	'createdBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Visibility': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orderType_SRL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orderType_PRL': {
	t: (args?: [...ArgTypes[]]) => string;};
	'each': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orderItem': {
	t: (args?: [...ArgTypes[]]) => string;};
	'manufacturer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selectAllProducts': {
	t: (args?: [...ArgTypes[]]) => string;};
	'editListDetails': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addSelectedToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'deleteSelected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'nProductsSel': {
	t: ({n}: TemplateArgs) => string;};
	'addProds': {
	t: (args?: [...ArgTypes[]]) => string;};
	'cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'saveChanges': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addListToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'deleteItem': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteDialogTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteDialogHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Confirm': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Select': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowAttributes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'HideAttributes': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'InprogressOrders': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateNewOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NewOrderName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PrivateOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SharedOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Columns': {
	'Active': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Name': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LastUpdated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Type': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Status': {
	'ORD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SHR': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'DeleteDialogTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteDialogHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CopyTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CopyMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentCart': {
	t: ({orderId}: TemplateArgs) => string;};
	'InvalidOrderName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchPh': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NotActiveOrderMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'InprogressItems': {
	'orderItem': {
	t: (args?: [...ArgTypes[]]) => string;};
	'creationDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'contributor': {
	t: (args?: [...ArgTypes[]]) => string;};
	'each': {
	t: (args?: [...ArgTypes[]]) => string;};
	'actions': {
	t: (args?: [...ArgTypes[]]) => string;};
	'inprogressOrders': {
	t: (args?: [...ArgTypes[]]) => string;};
	'createdBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	'lastUpdated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'totalPrice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'visibility': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orderType_SHR': {
	t: (args?: [...ArgTypes[]]) => string;};
	'orderType_ORD': {
	t: (args?: [...ArgTypes[]]) => string;};
	'proceed': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addProds': {
	t: (args?: [...ArgTypes[]]) => string;};
	'privateList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'sharedList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'nProductsSel': {
	t: ({n}: TemplateArgs) => string;};
	'addSelToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'deleteSelected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noItems': {
	t: (args?: [...ArgTypes[]]) => string;};
	'nameForCopiedOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'commonTable': {
	'ofTotalCount': {
	t: ({from, to, total}: TemplateArgs) => string;};
	'pageSz': {
	'five': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ten': {
	t: (args?: [...ArgTypes[]]) => string;};
	'twenty': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'rows': {
	t: (args?: [...ArgTypes[]]) => string;};
	'paginationText': {
	t: ({from, total}: TemplateArgs) => string;};
	};
	'WishList': {
	'CreateWishListTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CreateList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WishListName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoWishListMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoWishListExtraMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WishListEmptyMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'YourWishlistItems': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WishListItemsMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidWishListName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Confirm': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ConfirmDelete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RemoveItemsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ConfirmDeleteSelectedMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ConfirmDeleteMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ConfirmDeleteTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmptyWishListMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Share': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'AddToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectAll': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EditList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Delete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Save': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddSelectedToCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeletedSelected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeleteList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShareList': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'InvalidReceipientEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmptySenderName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EmptyReceipientEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidSenderEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'LoginMsgToAddToWishList': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ProductSelected': {
	t: ({n}: TemplateArgs) => string;};
	'DefaultWishListName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SendWishListHeader': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SendWishListText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SharedWishListIntro': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderMethod': {
	'Message': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Delivery': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Pickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'compare': {
	'compare': {
	t: (args?: [...ArgTypes[]]) => string;};
	'start': {
	t: ({n}: TemplateArgs) => string;};
	'tnail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'notavl': {
	t: (args?: [...ArgTypes[]]) => string;};
	'price': {
	t: (args?: [...ArgTypes[]]) => string;};
	'tabletOrDesk': {
	t: (args?: [...ArgTypes[]]) => string;};
	'goBack': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addAnother': {
	t: (args?: [...ArgTypes[]]) => string;};
	'prodComp': {
	t: (args?: [...ArgTypes[]]) => string;};
	'boxNofM': {
	t: ({n, m}: TemplateArgs) => string;};
	'clearSel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'hide': {
	t: (args?: [...ArgTypes[]]) => string;};
	'expand': {
	t: (args?: [...ArgTypes[]]) => string;};
	'compSel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'addAtLeast': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'sellers': {
	'seller': {
	t: (args?: [...ArgTypes[]]) => string;};
	'edit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'select': {
	t: (args?: [...ArgTypes[]]) => string;};
	'mp': {
	t: (args?: [...ArgTypes[]]) => string;};
	'emMp': {
	t: ({store}: TemplateArgs) => string;};
	'fBy': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreLocatorDialog': {
	'pickupLocation': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreLocator': {
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'home': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'placeholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'findNearestStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'selected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'setAsMyStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'hide': {
	t: (args?: [...ArgTypes[]]) => string;};
	'expand': {
	t: (args?: [...ArgTypes[]]) => string;};
	'clearSearch': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchResults': {
	t: ({n, p}: TemplateArgs) => string;};
	'searchResultsNearYou': {
	t: ({n}: TemplateArgs) => string;};
	'getDirections': {
	t: (args?: [...ArgTypes[]]) => string;};
	'stopDirections': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchAPickUpStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchStlocStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noResults': {
	t: ({p}: TemplateArgs) => string;};
	'noResultsNearYou': {
	t: (args?: [...ArgTypes[]]) => string;};
	'locateStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'directionNotAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentSelectedStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'distanceKM': {
	t: ({distance}: TemplateArgs) => string;};
	'storeHours': {
	t: ({displayName, displayValue}: TemplateArgs) => string;};
	'allIntertoysStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetBackLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetHeader': {
	t: ({street}: TemplateArgs) => string;};
	'storeStreetNearbyHeader': {
	t: ({street}: TemplateArgs) => string;};
	'storeStreetOpeningHours': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetSpecialOpeningHours': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetSpecialspecialactionHours': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetEvenementenHours': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetClickNCollectAllowed': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetDHLServicePoint': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetNintendoCorner': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetFanafdeling': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetLDSAllowed': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetMonday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetTuesday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetWednesday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetThursday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetFriday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetSaturday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetSunday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetClosedToday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetOpenToday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'storeStreetOpenTodayFromTo': {
	t: ({from}: TemplateArgs) => string;};
	'storeStreetGoToStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FindStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'searchStoreByLocation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noStoresNearby': {
	t: (args?: [...ArgTypes[]]) => string;};
	'locationPermissionDenied': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreInventoryDialog': {
	'InventoryDetailsWithStore': {
	t: ({store}: TemplateArgs) => string;};
	'InventoryDetailsWithoutStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreNotSelected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PleaseSelectAStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectedPickupLocation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CurrentSelectedStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreInfo': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Phone': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Labels': {
	'Pickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreList': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Inventory': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SetAsMyStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Selected': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Availability': {
	'Available': {
	t: ({count}: TemplateArgs) => string;};
	'NoInventoryShow': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OOS': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'StoreStock': {
	'InvMsg': {
	'INVMESSAGE_InStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_OutOfStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_LowStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_CallStoreStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_SufficientStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_StockstockPickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'CCInvMsg': {
	'INVMESSAGE_InStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_OutOfStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_LowStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_CallStoreStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_SufficientStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'INVMESSAGE_StockstockPickup': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'StoreStockHeaderLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FindStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewStoreOpeningHours': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowMore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noOptionsText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ViewStoreInventory': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FindAStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OpeningHours': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreClosedToday': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Error': {
	'SAPStockNotAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ClickAndCollect': {
	'PickUPAtThisStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreHoursLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreOpenOn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShowNearestStoresWithStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SearchByLocation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClickAndCollectNoStoresWithStock': {
	t: (args?: [...ArgTypes[]]) => string;};
	'StoreToyStoreKeyword': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClickAndCollect': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ClickAndCollectUSP': {
	t: (args?: [...ArgTypes[]]) => string;};
	'YourSelectedStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MoreInfo': {
	t: (args?: [...ArgTypes[]]) => string;};
	'DeliveryTypes': {
	t: (args?: [...ArgTypes[]]) => string;};
	'locationPermissionDenied': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'ChangeStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ProgressIndicator': {
	'label': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Files': {
	'Download': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PasswordInput': {
	'toggleLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Common': {
	'SkipToMainContent': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Actions': {
	'ContinueShopping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Cancel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'decrement': {
	t: (args?: [...ArgTypes[]]) => string;};
	'increment': {
	t: (args?: [...ArgTypes[]]) => string;};
	'quantity': {
	t: ({n}: TemplateArgs) => string;};
	'navHomeWithMessage': {
	t: ({message}: TemplateArgs) => string;};
	'SlideNextARIACommon': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SlidePreviousARIACommon': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SlideNextARIA': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SlidePreviousARIA': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'EmailTemplate': {
	'Approval': {
	'Greetings': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CloseEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgRegNotification': {
	t: ({organizationName}: TemplateArgs) => string;};
	'OrgAdminRegNotification': {
	t: ({adminName, organizationName}: TemplateArgs) => string;};
	};
	'OrderRejected': {
	'Greetings': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MessageDetails': {
	t: ({orderId}: TemplateArgs) => string;};
	};
	'Workspace': {
	'DearContentContributor': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TaskActivated': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TaskRejected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TaskGroupApproval': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Reseller': {
	'OrgRejected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrgApproved': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UserRejected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UserApproved': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Wishlist': {
	'MessageIntro': {
	t: ({senderName}: TemplateArgs) => string;};
	};
	'Order': {
	'Confirmation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderDetailsTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderPlacedDate': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShipAsComplete': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingInstructions': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'RequestedShippingDate': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'Expedited': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'Products': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Item': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'Quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Each': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Total': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderSummary': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderSubTotal': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TotalDiscount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Tax': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Shipping': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ShippingTax': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderTotal': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingInformation': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BillingMethod': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Amount': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoItems': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoPayments': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ItemShippingInfo': {
	t: (args?: [...ArgTypes[]]) => string;};
	'String_true': {
	t: (args?: [...ArgTypes[]]) => string;};
	'String_false': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Notification': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Meta': {
	'404': {
	'Title': {
	t: ({viewName}: TemplateArgs) => string;};
	};
	'ActivateTaskNotification': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ApproversNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'InterestItemListMessage': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MerchantOrderNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderAuthorized': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderCancel': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderChanged': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderReceived': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'OrderRejected': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PasswordNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PasswordResetConfirmationNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ReadyToApproveTaskGroupNotification': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RejectTaskNotification': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ReleaseShipNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ResellerRegistrationApprovedNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ResellerRegistrationRejectedNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'UserAccountEmailActivateNotify': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ContentFallback': {
	'PasswordNotify': {
	'messageAdmin': {
	t: ({userName, validationCode}: TemplateArgs) => string;};
	'message': {
	t: ({userName, validationCode}: TemplateArgs) => string;};
	};
	'PasswordResetConfirmationNotify': {
	'message': {
	t: ({userName}: TemplateArgs) => string;};
	};
	'UserAccountEmailActivateNotify': {
	'message': {
	t: (args?: [...ArgTypes[]]) => string;};
	'link': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	};
	'FreeGift': {
	'Add': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Remove': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Label': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Promotion': {
	t: ({promotion}: TemplateArgs) => string;};
	'SelectItem': {
	t: ({count}: TemplateArgs) => string;};
	'Qualify': {
	t: ({count}: TemplateArgs) => string;};
	'QualifyReminder': {
	t: ({count}: TemplateArgs) => string;};
	'PromotionItemNotAvailable': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RemoveFreeGiftFromCart': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'QuickOrder': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Quantity': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SKU': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OrderButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Reset': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NoSKUFound': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ErrorMsg': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AddMore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SignIn': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PrivacyPolicy': {
	'Buttons': {
	'All': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Selected': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Necessary': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Content': {
	'PrivacyModalPersonalInfoVersion1.0': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PrivacyModalMarketingVersion1.0': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PrivacyModalAnalyticsVersion1.0': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Tabs': {
	'Consent': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Customize': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Customize': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'NecessaryFunctional': {
	t: (args?: [...ArgTypes[]]) => string;};
	'MarketingAnalytics': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MarketingConsent': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'UserInactivityAlert': {
	'title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'primaryText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'secondaryText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'continueSession': {
	t: (args?: [...ArgTypes[]]) => string;};
	'logoutSession': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'VerifiedAddress': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Description': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EnteredAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RecommendedAddress': {
	t: (args?: [...ArgTypes[]]) => string;};
	'UseAddressButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CancelButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'MergeCartDialog': {
	'Title': {
	t: ({count}: TemplateArgs) => string;};
	'confirmButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'PdpExternalVideo': {
	'Labels': {
	'PlayVideo': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'NewsLetterSubscription': {
	'Labels': {
	'EmailId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubscriptionSubmit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Extra_interests': {
	t: (args?: [...ArgTypes[]]) => string;};
	'BabyPeuter': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Gaming': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'EmailPlaceholder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessLabel': {
	t: (args: [ArgTypes, ...ArgTypes[]]) => string;};
	'Msgs': {
	'EmailRequired': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InvalidEmail': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'AccountNewsLetterSubscription': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Message': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Error': {
	'AlreadySubscribed': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AlreadyUnsubscribed': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'Submit': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'FormVaidations': {
	'Errors': {
	'ERROR_FormFieldEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_FirstLastName': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_FirstNameEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_LastNameEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_LastNameTooLong': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_EmailEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_EmailTooLong': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_INVALIDEMAILFORMAT': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_PhonenumberEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_DOBEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_CampaignTxtEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_CampaignAnsTxtEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_AgeEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_InvalidAge': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_StreetEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_HouseNoEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_ZipCodeEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_ZipCodeTooLong': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_PostalCodeInvalidFormat': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_PlaceEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_InvalidChallengeAnswer': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_AcceptActieTerms': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ReturnOrder': {
	'Labels': {
	'orderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'postCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'houseNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'houseNumberSubtext': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Back': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Submit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectProductSubmit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectReasonSubmit': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Download': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ExchangeAndReturn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TryAgain': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'AdressForm': {
	'OrderNumberText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'WhereToFindOrderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Klantenservice': {
	t: (args?: [...ArgTypes[]]) => string;};
	'KlantenserviceLink': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ProductSelect': {
	'selectProductData': {
	t: (args?: [...ArgTypes[]]) => string;};
	'noProductData': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ReasonSelect': {
	'selectItemText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'hyphens': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SelectReturnReason': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ReturnReasonQuestion': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'DownloadForm': {
	'thanksForReturn': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ReturnOrderNextSteps': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Main': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'orderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Errors': {
	'ERROR_RETURN_ORDER_NUMBER_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_ZIPCODE_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_HOUSE_NUMBER_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_NO_PRODUCT_SELECTION': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_QUANTITY_MORE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_QUANTITY_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_QUANTITY_ZERO': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_RETURN_REASON_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_NO_ORDER_FOUND_FOR_RETURN_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_NO_ORDER_FOUND_FOR_REVOKE_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_RETURN_PROCESSED_ALREADY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_THRESHOLD_REACHED_FOR_ORDER_PROCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_THRESHOLD_REACHED_FOR_REVOKE_ORDER_PROCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_STORE_PICKUP_RETURNS_UNAVAILABLE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_OMS_RETURNS_SYSTEM_UNAVAILABLE': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_REVOKE_NOT_ALLOWED_FOR_BUSINESS_ORDER': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'StoreStockPage': {
	'Search': {
	t: (args?: [...ArgTypes[]]) => string;};
	'findStore': {
	t: (args?: [...ArgTypes[]]) => string;};
	'partNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'zipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'helperText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'error': {
	'partNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'zipCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ErrorMessage': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'LegoLoyaltyForLego': {
	'NewRequestToken': {
	'Header': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountNrInfoText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckBoxText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckBoxLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'CardNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApplyCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EnterCardNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RemoveCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Summary': {
	'Header': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PointsEarnedInThisOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountBalance': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'InfoPopup': {
	'Header': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InfoText': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Errors': {
	'CardNumberEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CardNumberInvalid': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'LegoLoyaltyForToet': {
	'NewRequestToken': {
	'Header': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountNrInfoText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckBoxText': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CheckBoxLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Actions': {
	'CardNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ApplyCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	'EnterCardNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RemoveCard': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Summary': {
	'Header': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PointsEarnedInThisOrder': {
	t: (args?: [...ArgTypes[]]) => string;};
	'AccountBalance': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'InfoPopup': {
	'Header': {
	t: (args?: [...ArgTypes[]]) => string;};
	'InfoText': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Errors': {
	'CardNumberEmpty': {
	t: (args?: [...ArgTypes[]]) => string;};
	'CardNumberInvalid': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'CancelOrderOMS': {
	'Labels': {
	'postCode': {
	t: (args?: [...ArgTypes[]]) => string;};
	'houseNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FailureButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'TryAgain': {
	t: (args?: [...ArgTypes[]]) => string;};
	'PopupTitle': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Main': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'orderNumber': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Errors': {
	'ERROR_ORDER_NUMBER_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_ZIPCODE_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'ERROR_HOUSE_NUMBER_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_NO_ORDER_FOUND_FOR_OMSCANCEL_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_403_FOR_OMSCANCEL_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_422_FOR_OMSCANCEL_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_NO_ORDER_FOUND_FOR_OMSPROCESS_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'_ERR_422_FOR_OMSPROCESS_PROCESSING': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OMS_CANCEL_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'OMS_PROCESS_SUCCESS': {
	t: (args?: [...ArgTypes[]]) => string;};
	'FIELDS_EMPTY': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ResendActivationEmail': {
	'Title': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Header1': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Header2': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SendMailButton': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SuccessLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Label': {
	'LogonId': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Email': {
	t: (args?: [...ArgTypes[]]) => string;};
	'rememberMe': {
	t: (args?: [...ArgTypes[]]) => string;};
	'Password': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'Msgs': {
	'MailSent': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	'ScrollUp': {
	'ariaLabel': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'EaaMessages': {
	'productLinkPrefix': {
	t: (args?: [...ArgTypes[]]) => string;};
	'priceSuffixOfferPLP': {
	t: ({offerPriceEAA}: TemplateArgs) => string;};
	'priceSuffixListAndOfferPLP': {
	t: ({offerPriceEAA, listPriceEAA}: TemplateArgs) => string;};
	};
	'SearchResults': {
	'searchResultsH1': {
	t: ({term}: TemplateArgs) => string;};
	};
	'RevokeOrder': {
	'Main': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	'SubHeading': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'RevokeOrderForm': {
	'Heading': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'DownloadForm': {
	'thanksForRevoke': {
	t: (args?: [...ArgTypes[]]) => string;};
	'RevokeOrderNextSteps': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	'ProductSelect': {
	'selectProductData': {
	t: (args?: [...ArgTypes[]]) => string;};
	};
	};
	
}

export const requestTranslation = async ({
    locale,
    section,
}: {
    locale: Languages | string;
    section: Sections | string;
}) => {
    if (!manifest[locale] || typeof manifest[locale][section] !== 'function') {
        return {};
    }
    const loaded = await manifest[locale][section]();
    return JSON.parse(JSON.stringify(loaded.default)) as Translation;
};
